import React from "react";

function ApplicationCandidacy() {
  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h1>Application Candidacy</h1>
      <p style={{ color: "gray" }}>Content for Application Candidacy will be added soon.</p>
    </div>
  );
}

export default ApplicationCandidacy;
